const modals: string[] = [];

export const modalManager = {
	modals: () => modals,
	add: (modalId: string) => {
		if (modals.indexOf(modalId) === -1) {
			modals.push(modalId);
		}
	},
	remove: (modalId: string) => {
		const index = modals.indexOf(modalId);
		if (index !== -1) {
			modals.splice(index, 1);
		}
	},
	/**
	 * Check if the modal is the first one on the screen
	 */
	isTopModal: (modalId: string) => !!modals.length && modals[modals.length - 1] === modalId,
};
